// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"439":"1921bfdf","492":"1921bfdf","734":"7b22bb24"}[chunkId] + ".chunk.css";
};